module.exports = __webpack_public_path__ + "media/images/game/bydleni-80544c7f0990f400360eac2a7242202c.png";